module.exports = __webpack_public_path__ + "img/Lokale_Belieferung_Banner_LoginSeite.74e4788f.webp";